// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NYhB","colMin":"styles_colMin__1TSKt"};